<template>
    <div class="pi-page">
        <div class="pi-scroll">
            <section class="pi-section">
                <h2 class="pi-section__title">
                    基本资料
                </h2>
                <ul class="pi-list">
                    <li v-for="row in rows" :key="row.key" class="pi-row">
                        <span class="pi-row__label">{{row.label}}</span>
                        <span class="pi-row__value">{{row.text}}</span>
                    </li>
                </ul>
            </section>
        </div>

        <div class="pi-footer">
            <button type="button" class="pi-btn-main" @click="goExport">
                个人信息导出
            </button>
        </div>
    </div>
</template>

<script>
import {Toast} from 'vant';

function isApiSuccess(res) {
    return res && (res.code === 0 || res.code === '0');
}

function safeDecode(value) {
    if (value == null || value === '') {
        return '';
    }
    try {
        return decodeURIComponent(String(value));
    }
    catch (e) {
        return String(value);
    }
}

function trimField(value) {
    return value == null ? '' : String(value).trim();
}

export default {
    name: 'PersonalInfoView',
    components: {
    },
    data() {
        return {
            raw: {},
        };
    },
    computed: {
        rows() {
            const data = this.raw || {};
            const nickname = safeDecode(trimField(data.nickName));
            const birthday = trimField(data.birthday);
            const gender = trimField(data.gender);
            const phone = trimField(data.phone);
            const address = trimField(data.address);

            const mk = (key, label, rawVal) => {
                let s = rawVal;
                if (key === 'gender' && s === '未填写') {
                    s = '';
                }
                const isEmpty = s === '';
                return {
                    key,
                    label,
                    text: isEmpty ? '未填写' : s,
                };
            };

            return [
                mk('nickname', '昵称', nickname),
                mk('birthday', '生日', birthday),
                mk('gender', '性别', gender),
                mk('phone', '手机号', phone),
                mk('address', '物流地址', address),
            ];
        },
    },
    mounted() {
        document.title = '个人信息';
        this.fetchUser();
    },
    methods: {
        goExport() {
            this.$router.push({
                name: 'personalInfoExport',
                query: {...this.$route.query},
            });
        },
        fetchUser() {
            const {uid} = this.$route.query;
            if (!uid) {
                Toast.fail('缺少用户参数，无法加载信息');
                return;
            }
            this.$http.get(this.$Api.personalInfo, {uid})
                .then(res => {
                    if (isApiSuccess(res) && res.data) {
                        this.raw = res.data;
                    }
                    else {
                        Toast.fail(res?.msg || '获取用户信息失败');
                    }
                })
                .catch(function handleFetchUserError() {
                    // 网络异常已由 http 拦截器提示
                });
        },
    },
};
</script>

<style lang="scss" scoped>
$accent: #ff5242;
$text: #222;
$value: #999;
$line: #eee;

.pi-page {
    box-sizing: border-box;
    min-height: 100vh;

    max-width: 520px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: #fff;
    color: $text;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", sans-serif;
}

.pi-nav {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    padding: 0 16px;
    border-bottom: 1px solid $line;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 2;
}

.pi-nav__title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
    line-height: 44px;
}

.pi-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 16px 20px 12px;
}

.pi-section__title {
    margin: 0 0 14px;
    font-size: 17px;
    font-weight: 600;
}

.pi-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.pi-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 0;
    border-bottom: 1px solid $line;
    font-size: 15px;
}

.pi-row:last-child {
    border-bottom: 0;
}

.pi-row__label {
    flex-shrink: 0;
    color: $text;
}

.pi-row__value {
    text-align: right;
    color: $value;
    word-break: break-all;
}

.pi-footer {
    flex-shrink: 0;
    padding: 12px 20px calc(12px + env(safe-area-inset-bottom, 0px));
    background: #fff;
    border-top: 1px solid $line;
}

.pi-btn-main {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: 0;
    border-radius: 25px;
    padding: 14px 16px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: $accent;
    cursor: pointer;
}

@media (orientation: landscape) and (max-height: 420px) {
    .pi-section__title {
        margin-bottom: 8px;
        font-size: 16px;
    }

    .pi-row {
        padding: 10px 0;
        font-size: 14px;
    }

    .pi-footer {
        padding-top: 8px;
        padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
    }

    .pi-btn-main {
        padding: 10px 16px;
    }
}
</style>
